import { object, string } from '@gogame/schemas';

export const formScreenSchema = object({});

export const previewScreenSchema = object({
  version: string(),
});
